import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'

import { CustomConfirmDialog } from '../../../../../../../../components/dialogs'
import { useToastContext } from '../../../../../../../../contexts'
import { DeliveryForecastItemSplit } from '../../../../../../../../data/models'
import { getHandleableError } from '../../../../../../../../utils/errors/isXiaError'
import { requestDeleteSplitItem } from '../../../../../../data/api'

type DeleteSplitItemProps = {
  deliveryForecastId: string
  itemId: string
  itemSplit?: DeliveryForecastItemSplit
}

export const DeleteSplitItem: React.FC<DeleteSplitItemProps> = ({
  deliveryForecastId,
  itemId,
  itemSplit,
}) => {
  const { t } = useTranslation()
  const { replaceToast } = useToastContext()
  const [isVisible, setIsVisible] = useState(false)

  const handleShow = () => setIsVisible(true)
  const handleHide = () => setIsVisible(false)

  const handleAccept = async () => {
    try {
      await requestDeleteSplitItem(deliveryForecastId, itemId, itemSplit?.Id!)
      replaceToast({
        id: `delete-split-item`,
        style: {},
        closable: true,
        severity: 'success',
        summary: t(
          'deliveryForecast.deliveryScheduleDetails.splits.table.delete.messages.success.summary',
        ),
        detail: t(
          'deliveryForecast.deliveryScheduleDetails.splits.table.delete.messages.success.detail',
          {
            count: 1,
          },
        ),
      })
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      replaceToast({
        id: `delete-split-item`,
        style: {},
        closable: true,
        severity: 'error',
        sticky: true,
        summary: t(
          'deliveryForecast.deliveryScheduleDetails.splits.table.delete.messages.failure.summary',
        ),
        detail: errorMessage,
      })
    } finally {
      setIsVisible(false)
    }
  }

  if (!itemSplit) return null
  if (itemSplit.Status !== 'ADDED') return null

  return (
    <>
      <Button
        icon="pi pi-trash"
        className="p-button-rounded p-button-text hover:p-button-danger"
        onClick={handleShow}
      />

      <CustomConfirmDialog
        severity="danger"
        isVisible={isVisible}
        header={t(
          'deliveryForecast.deliveryScheduleDetails.splits.table.delete.dialog.header',
        )}
        message={t(
          'deliveryForecast.deliveryScheduleDetails.splits.table.delete.dialog.message',
        )}
        onHide={handleHide}
        onReject={handleHide}
        onAccept={handleAccept}
        rejectLabel={t('common.buttons.cancel')}
        acceptLabel={t('common.buttons.delete')}
      />
    </>
  )
}
